import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39de7f91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-2"
}
const _hoisted_3 = {
  key: 0,
  class: "pa-3"
}
const _hoisted_4 = {
  key: 0,
  class: "text-center text-medium-emphasis pa-6"
}
const _hoisted_5 = {
  key: 0,
  class: "text-center text-medium-emphasis pa-6"
}
const _hoisted_6 = { class: "d-flex align-center ga-2 min-w-0" }
const _hoisted_7 = { class: "font-weight-bold text-truncate" }
const _hoisted_8 = { class: "text-caption text-medium-emphasis flex-shrink-0" }

import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { Torneo, TorneoGestionInfoDTO, TorneoGestionInfoMasDTO } from "@/interfaces/Torneo";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import { JugadorListas, ListaDeJugador, ListaJugador } from "@/interfaces/Lista";
import { getListaById } from "@/services/ListasService";
import {
  getInfoTorneoCreado,
  getInfoTorneoCreadoMasAsync,
  getInfoTorneoEquipoCreado,
} from "@/services/TorneosService";
import { appsettings } from "@/settings/appsettings";
import { esUsuarioBye } from "@/utils/bye";
import ModalVerLista from "../Inscripcion/ModalVerLista.vue";
import FilaListasJugador from "./FilaListasJugador.vue";

type Bando = "good" | "evil";
type Filtro = "todos" | Bando;
interface EquipoListas {
  nombre: string;
  jugadores: JugadorListas[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TabMostrarListas',
  props: {
    torneo: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const isLoading = ref(true);
const search = ref<string | null>("");
const filtroBando = ref<Filtro>("todos");
const jugadores = ref<JugadorListas[]>([]);
const equipos = ref<EquipoListas[]>([]);
const equiposAbiertos = ref<string[]>([]);
const cargandoLista = ref<number | null>(null);
const listaJugador = ref<ListaJugador>();
const showVerListaModal = ref(false);

const porEquipos = computed(() => !!props.torneo && props.torneo.tipoTorneo !== "Individual");

// El bando de la lista o, si no viene, el de su ejército
const bandoDe = (bando?: string | null, ejercito?: string | null): Bando | null => {
  if (bando === "good" || bando === "evil") return bando;
  const band = appsettings.armies.find(e => e.name === ejercito)?.band;
  return band === "good" || band === "evil" ? band : null;
};

const lista = (idLista?: number | null, ejercito?: string | null, bando?: string | null): ListaDeJugador[] =>
  idLista ? [{ idLista, ejercito: ejercito ?? "Sin ejército", bando: bandoDe(bando, ejercito) }] : [];

const porNick = (a: JugadorListas, b: JugadorListas) =>
  a.nick.localeCompare(b.nick, "es", { sensitivity: "base" });

watch(
  () => props.torneo,
  async torneo => {
    if (!torneo) return;
    isLoading.value = true;
    try {
      if (torneo.tipoTorneo !== "Individual") {
        const info: TorneoEquipoGestionInfoDTO = (await getInfoTorneoEquipoCreado(torneo.idTorneo)).data;
        equipos.value = (info.equipos ?? [])
          .filter(e => !esUsuarioBye(e.idCapitan, e.nombreEquipo))
          .map(e => ({
            nombre: e.nombreEquipo ?? "Equipo",
            jugadores: e.inscripciones
              .map(i => ({
                idUsuario: i.idUsuario,
                nick: i.nick,
                listas: lista(i.idLista, i.ejercito, i.bando),
              }))
              .sort(porNick),
          }))
          .sort((a, b) => a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" }));
      } else if ((torneo.listasPorJugador ?? 1) > 1) {
        // Varias listas por jugador: todas las que ha entregado
        const info: TorneoGestionInfoMasDTO = (await getInfoTorneoCreadoMasAsync(torneo.idTorneo)).data;
        jugadores.value = (info.inscripciones ?? [])
          .filter(i => !esUsuarioBye(i.idUsuario, i.nick))
          .map(i => ({
            idUsuario: i.idUsuario,
            nick: i.nick,
            listas: (i.lista ?? []).flatMap(l => lista(l.idLista, l.ejercito, l.bando)),
          }))
          .sort(porNick);
      } else {
        const info: TorneoGestionInfoDTO = (await getInfoTorneoCreado(torneo.idTorneo)).data;
        jugadores.value = (info.inscripciones ?? [])
          .filter(i => !esUsuarioBye(i.idUsuario, i.nick))
          .map(i => ({
            idUsuario: i.idUsuario,
            nick: i.nick ?? "",
            listas: lista(i.idLista, i.ejercito, i.bando),
          }))
          .sort(porNick);
      }
    } catch (error) {
      console.error("Error al obtener las listas:", error);
    } finally {
      isLoading.value = false;
    }
  },
  { immediate: true }
);

// Búsqueda sin tildes ni mayúsculas
const normalizar = (texto: string) =>
  texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
const texto = computed(() => normalizar((search.value ?? "").trim()));

// Las listas que pasan el filtro de bando; con «Todas», también quien aún no ha entregado
const filtrarJugador = (jugador: JugadorListas, extra = ""): JugadorListas | null => {
  const listas =
    filtroBando.value === "todos"
      ? jugador.listas
      : jugador.listas.filter(l => l.bando === filtroBando.value);
  if (filtroBando.value !== "todos" && listas.length === 0) return null;
  if (texto.value) {
    const donde = normalizar([extra, jugador.nick, ...listas.map(l => l.ejercito)].join(" "));
    if (!donde.includes(texto.value)) return null;
  }
  return { ...jugador, listas };
};

const jugadoresVisibles = computed(() =>
  jugadores.value.map(j => filtrarJugador(j)).filter((j): j is JugadorListas => j !== null)
);

const equiposVisibles = computed(() =>
  equipos.value
    .map(e => ({
      ...e,
      total: e.jugadores.length,
      jugadores: e.jugadores
        .map(j => filtrarJugador(j, e.nombre))
        .filter((j): j is JugadorListas => j !== null),
    }))
    .filter(e => e.jugadores.length > 0)
);

// Al buscar o filtrar se abren los equipos que coinciden
watch([texto, filtroBando], () => {
  equiposAbiertos.value = texto.value || filtroBando.value !== "todos" ? equiposVisibles.value.map(e => e.nombre) : [];
});

const todasLasListas = computed(() =>
  (porEquipos.value ? equipos.value.flatMap(e => e.jugadores) : jugadores.value).flatMap(j => j.listas)
);
const cuentaBando = computed(() => ({
  todos: todasLasListas.value.length,
  good: todasLasListas.value.filter(l => l.bando === "good").length,
  evil: todasLasListas.value.filter(l => l.bando === "evil").length,
}));

const resumen = computed(() => {
  if (porEquipos.value) {
    const n = equipos.value.length;
    const nombre = props.torneo?.tipoTorneo === "Parejas" ? (n === 1 ? "pareja" : "parejas") : n === 1 ? "equipo" : "equipos";
    return `${n} ${nombre} · ${cuentaBando.value.todos} listas`;
  }
  const n = jugadores.value.length;
  return `${n} ${n === 1 ? "jugador" : "jugadores"} · ${cuentaBando.value.todos} listas`;
});

const textoVacio = computed(() =>
  texto.value || filtroBando.value !== "todos"
    ? "Nada coincide con la búsqueda."
    : "Todavía no hay inscritos."
);

const verLista = async (jugador: JugadorListas, listaElegida: ListaDeJugador) => {
  cargandoLista.value = listaElegida.idLista;
  try {
    const { data } = await getListaById(listaElegida.idLista);
    listaJugador.value = { listaData: data.listaData, nick: jugador.nick, nombreEjercito: listaElegida.ejercito };
    showVerListaModal.value = true;
  } catch (error) {
    console.error("Error al cargar la lista:", error);
  } finally {
    cargandoLista.value = null;
  }
};

const goToUserDetail = (idUsuario: number) => {
  router.push({ name: "detalle-jugador", params: { idUsuario } });
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      flat: "",
      class: "listas-live mx-auto"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(resumen.value), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_v_text_field, {
            modelValue: search.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            placeholder: porEquipos.value ? 'Buscar equipo, jugador o ejército' : 'Buscar jugador o ejército',
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            clearable: "",
            class: "mb-2"
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_v_chip_group, {
            modelValue: filtroBando.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtroBando).value = $event)),
            mandatory: "",
            "selected-class": "text-primary",
            column: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip, {
                value: "todos",
                size: "small",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Todas (" + _toDisplayString(cuentaBando.value.todos) + ")", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                value: "good",
                size: "small",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Luz (" + _toDisplayString(cuentaBando.value.good) + ")", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                value: "evil",
                size: "small",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Oscuridad (" + _toDisplayString(cuentaBando.value.evil) + ")", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_divider),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createVNode(_component_v_skeleton_loader, {
                  key: n,
                  type: "list-item-avatar-two-line"
                })
              }), 64))
            ]))
          : (!porEquipos.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (jugadoresVisibles.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(textoVacio.value), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jugadoresVisibles.value, (jugador) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: jugador.idUsuario,
                    class: "fila-jugador"
                  }, [
                    _createVNode(FilaListasJugador, {
                      jugador: jugador,
                      cargandoLista: cargandoLista.value,
                      onVer: verLista,
                      onPerfil: goToUserDetail
                    }, null, 8, ["jugador", "cargandoLista"])
                  ]))
                }), 128))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (equiposVisibles.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(textoVacio.value), 1))
                  : (_openBlock(), _createBlock(_component_v_expansion_panels, {
                      key: 1,
                      modelValue: equiposAbiertos.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((equiposAbiertos).value = $event)),
                      multiple: "",
                      variant: "accordion"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equiposVisibles.value, (equipo) => {
                          return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                            key: equipo.nombre,
                            value: equipo.nombre
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(equipo.nombre), 1),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(equipo.total) + " " + _toDisplayString(equipo.total === 1 ? "jugador" : "jugadores"), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_expansion_panel_text, { class: "panel-equipo" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equipo.jugadores, (jugador) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: jugador.idUsuario,
                                      class: "fila-jugador"
                                    }, [
                                      _createVNode(FilaListasJugador, {
                                        jugador: jugador,
                                        cargandoLista: cargandoLista.value,
                                        onVer: verLista,
                                        onPerfil: goToUserDetail
                                      }, null, 8, ["jugador", "cargandoLista"])
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
              ], 64))
      ]),
      _: 1
    }),
    _createVNode(ModalVerLista, {
      isVisible: showVerListaModal.value,
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => ((showVerListaModal).value = $event)),
      listaJugador: listaJugador.value!
    }, null, 8, ["isVisible", "listaJugador"])
  ], 64))
}
}

})